/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informace o dopravě`
};

const da_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Leveringsoplysninger`
};

const de_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Versandinformationen`
};

const en_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Shipping information`
};

const es_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Información de envío`
};

const fr_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informations de livraison`
};

const hu_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítási adatok`
};

const it_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informazioni di spedizione`
};

const nl_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Verzendgegevens`
};

const pl_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Dane do wysyłki`
};

const pt_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informações de envio`
};

const sv_shipping_information = /** @type {(inputs: {}) => string} */ () => {
	return `Leveransinformation`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipping_information = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipping_information(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipping_information", locale)
	if (locale === "cs") return cs_shipping_information(inputs)
	if (locale === "da") return da_shipping_information(inputs)
	if (locale === "de") return de_shipping_information(inputs)
	if (locale === "en") return en_shipping_information(inputs)
	if (locale === "es") return es_shipping_information(inputs)
	if (locale === "fr") return fr_shipping_information(inputs)
	if (locale === "hu") return hu_shipping_information(inputs)
	if (locale === "it") return it_shipping_information(inputs)
	if (locale === "nl") return nl_shipping_information(inputs)
	if (locale === "pl") return pl_shipping_information(inputs)
	if (locale === "pt") return pt_shipping_information(inputs)
	return sv_shipping_information(inputs)
};